import { z } from "zod";

const requiredText = (label: string) => z.string().trim().min(1, `${label} is required.`);
const phone = z.string().regex(/^\d{10}$/, "Enter a 10-digit contact number.");

export const personalDetailsSchema = z.object({
  firstName: requiredText("First name"),
  lastName: requiredText("Last name"),
  contactNumber: phone,
  alternateContactNumber: z.union([z.literal(""), phone]),
  correspondenceAddress: requiredText("Correspondence address"),
});

export const bankDetailsSchema = z.object({
  accountName: requiredText("Account name"),
  accountNumber: requiredText("Account number").regex(/^\d+$/, "Enter a valid account number."),
  pan: z.string().trim().regex(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Enter a valid PAN (e.g., ABCDE1234F)."),
  bankName: requiredText("Bank name"),
  branchName: z.string().trim(),
  ifscCode: z.string().trim().regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC code (e.g., SBIN0001234)."),
});

export type ConsultantIndiaValues = z.infer<typeof personalDetailsSchema> & z.infer<typeof bankDetailsSchema>;

export const EMPTY_VALUES: ConsultantIndiaValues = {
  firstName: "",
  lastName: "",
  contactNumber: "",
  alternateContactNumber: "",
  correspondenceAddress: "",
  accountName: "",
  accountNumber: "",
  pan: "",
  bankName: "",
  branchName: "",
  ifscCode: "",
};
